import axios from 'axios';
import config from '../../config/main';

const getPaintOrdersByDate = async (data) => {
  try {
    const returns = await axios({
      method: 'POST',
      url: `${config.apiEndpoint}/paint-orders-info`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache',
      },
      data,
      withCredentials: true,
    });
    return returns.data;
  } catch (err) {
    throw new Error(err);
  }
};

const savePaintOrders = async (data) => {
  try {
    const returns = await axios({
      method: 'POST',
      url: `${config.apiEndpoint}/paint-orders`,
      data,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache',
      },
      withCredentials: true,
    });
    return returns.data;
  } catch (err) {
    throw new Error(err);
  }
};

const deletePainOrdersById = async (id) => {
  try {
    const returns = await axios({
      method: 'DELETE',
      url: `${config.apiEndpoint}/paint-orders/${id}`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache',
      },
      withCredentials: true,
    });
    return returns.data;
  } catch (err) {
    throw new Error(err);
  }
};


export default {
  getPaintOrdersByDate,
  savePaintOrders,
  deletePainOrdersById
};